import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { popUpMenuChange,
        selectedCardsGroupsChange,
        standByCardsGroupsChange,
        selectedTeamIdsChange,
        toggleSwitch } from '../../actions/index';

import Icon from '@mdi/react';
import { mdiFileSend } from '@mdi/js';

import { _ } from '../../functions/translator'
import { ToggleActions } from '../../constants/constants';
import { findDuplicateTeamGroups } from '../../functions/finder';

class ReleaseButton extends React.Component{
          
    getTotalStandBy = () => {
        let text = ''
        if (this.props.standByCardsGroups.length > 0) {
            text += '(' + this.props.standByCardsGroups.length + ' '
            text += this.props.standByCardsGroups.length > 1 ? _('disponibles') + ')' : _('disponible') + ')'
        }
        return text
    }

    handleClick = () => {        
        this.props.standByCardsGroupsChange(this.props.standByCardsGroups);
        this.props.popUpMenuChange({ show: false });
        this.props.selectedCardsGroupsChange([]);

        const { autoAssign, duplicates } = findDuplicateTeamGroups(
            this.props.standByCardsGroups,
            this.props.projectData.cards_groups,
            this.props.projectData.teams
        );

        if (Object.keys(duplicates).length > 0) {
            this.props.toggleSwitch(ToggleActions.TEAM_SELECTOR);
        } else {
            this.props.selectedTeamIdsChange(autoAssign);
            this.props.toggleSwitch(ToggleActions.RELEASE_DATE);
        }
    }

    render(){   

        let totalStandBy = this.getTotalStandBy()
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref } onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiFileSend } size='30px' color='white' style={{margin: 10}}/>
                        <p>{ _('Liberar') }<span>{ totalStandBy }</span></p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        projectData : state.projectData,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        standByCardsGroupsChange :standByCardsGroupsChange,
        selectedTeamIdsChange : selectedTeamIdsChange,
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ReleaseButton)